import { FC } from 'react';
import './StepImport.scss';
import { ReactComponent as IconFiles } from 'assets/img/icons/icon_Files.svg';


interface Props {
  onUploadClick: () => void;
}

const StepImport: FC<Props> = ({ onUploadClick }) => (
  <div className="step-import">
    <div className="step-import__area">
      <button
        className="step-import__btn"
        onClick={onUploadClick}
        type="button"
        aria-label="Importer des fichiers"
      >
        <IconFiles fill={"#2f62ae"} width={30}/>
        <span>Importer</span>
      </button>
      <p className="step-import__hint">
        Protégez vos documents en ajoutant un filigrane personnalisé.
        Pour commencer importez les documents concernés.
      </p>
    </div>
  </div>
);

export default StepImport;
